module.exports = __webpack_public_path__ + "assets/dfb3b9f7ce86c4a8ea67e21033f6e969.png";